import React, { useEffect } from "react"
import { Box, Stack, Typography } from "@mui/material"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"

const DASHBOARD_REDIRECT_DELAY_MS = 1400

const BillingSuccess: React.FC = () => {
  useEffect(() => {
    const redirectTimer = window.setTimeout(() => {
      window.location.href = "/"
    }, DASHBOARD_REDIRECT_DELAY_MS)

    return () => window.clearTimeout(redirectTimer)
  }, [])

  return (
    <Box
      alignItems="center"
      justifyContent="center"
      width="100%"
      alignContent="center"
      alignSelf="center"
      display="flex">
      <Stack alignItems="center" gap={3} maxWidth={400} textAlign="center" p={4}>
        <CheckCircleIcon sx={{ fontSize: 72, color: "success.main" }} />
        <Typography variant="h5" fontWeight={700}>
          Credits added!
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Your image credits have been added to your account. Redirecting to your dashboard…
        </Typography>
      </Stack>
    </Box>
  )
}

export default BillingSuccess
